import React, { useEffect, useRef, useState } from 'react';
import { Users, Award, Activity, TrendingUp } from 'lucide-react';
import { trustStats } from '../data/mockData';
import '../styles/TrustStatsSection.css';

const TrustStatsSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [counts, setCounts] = useState(trustStats.map(() => 0));
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !isVisible) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, [isVisible]);

  useEffect(() => {
    if (isVisible) {
      trustStats.forEach((stat, index) => {
        const duration = 2000;
        const steps = 60;
        const increment = stat.value / steps;
        let currentStep = 0;

        const timer = setInterval(() => {
          currentStep++;
          setCounts(prev => {
            const newCounts = [...prev];
            newCounts[index] = Math.min(Math.floor(increment * currentStep), stat.value);
            return newCounts;
          });

          if (currentStep >= steps) {
            clearInterval(timer);
          }
        }, duration / steps);
      });
    }
  }, [isVisible]);

  const icons = [Users, Award, Activity, TrendingUp];

  return (
    <section className="trust-stats-section" ref={sectionRef}>
      <div className="trust-stats-container">
        {trustStats.map((stat, index) => {
          const Icon = icons[index];
          return (
            <div key={index} className="stat-card">
              <div className="stat-icon">
                <Icon size={28} />
              </div>
              <div className="stat-content">
                <div className="stat-value">
                  {counts[index].toLocaleString()}{stat.suffix}
                </div>
                <div className="stat-label">{stat.label}</div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default TrustStatsSection;
